import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from 'mui-datatables';
import IconButton from '@mui/material/IconButton';
import MatButton from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Selectsearch from "react-select";
import {
    FormGroup,
    Label,

} from 'reactstrap';
import { getEndingContract, getMonthEndContract,emailContractEnding } from 'Actions';

class ContractsEndings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewdiv: true,
      months: [],
      viewmonth:false,
      selectedMonth: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.props.getEndingContract();
    this.generateMonthList();
  }

  generateMonthList() {
    const currentDate = new Date();
    const months = Array.from({ length: 12 }, (_, index) => {
      const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + index, 1);
      const month = newDate.toLocaleString('en-US', { month: 'long' });
      const year = newDate.getFullYear();
      const value = `${newDate.getMonth() + 1}-${year}`;
      const label = `${month} ${year}`;

      return { value, label };
    });

    this.setState({ months });
  }

  handleChange = (selectedOption) => {
    this.setState({ viewmonth: false, selectedMonth: selectedOption.value });
    if (selectedOption.value) {
      this.props.getMonthEndContract(selectedOption.value)
        .then(() => {
          this.setState({ viewmonth: true });
        });
    }
  }
  
  onSendEmail(ctid){
    var selmonth=this.state.selectedMonth;
    this.props.emailContractEnding(ctid).then((data) => {
      this.props.getEndingContract();
      this.props.getMonthEndContract(selmonth);
    });
  }

  render() {
    const { match, contractendinglist, monthcontract, loading } = this.props;
    const { viewmonth, months } = this.state;
    const options = {
      filterType: 'dropdown',
      rowsPerPage: 50,
      responsive:'standard',
      rowsPerPageOptions: [50, 100, 150],
      selectableRowsHideCheckboxes: true,
    };

  const columns = [
  { name: 'sno', label: 'SNO.' },
  { name: 'student', label: 'STUDENT' },
  { name: 'agreementtype', label: 'AGREEMENT TYPE' },
  { name: 'executiondate', label: 'EXECUTION DATE' },
  { name: 'startdate', label: 'AGREEMENT START DATE' },
  { name: 'enddate', label: 'AGREEMENT END DATE' },
  { name: 'action', label: 'ACTION' },
];

const tableData = contractendinglist.map((assmntval, idx) => {
  if (assmntval.ctsa_endingmail == 1) {
    var shbtn = 'mr-10 mb-10 btn btn-info btn-sm text-white';
    var btl = 'Sent';
  } else {
    var shbtn = 'mr-10 mb-10 btn btn-sm text-white bg-secondary border-0';
    var btl = 'Send Email';
  }
  const mailbtn = (
    <MatButton className={shbtn} onClick={() => this.onSendEmail(assmntval.ctsaID)}>
      {btl}
    </MatButton>
  );
      return {
        sno: idx + 1,
        student: assmntval.studentname,
        agreementtype: assmntval.agreementtype,
        executiondate: assmntval.exdate,
        startdate: assmntval.stdate,
        enddate: assmntval.eddate,
        action:mailbtn,
      };
    });

    const tableData2 = monthcontract.map((assmntval, idx) => {
      if(assmntval.ctsa_endingmail==1){
        var shbtn='mr-10 mb-10 btn btn-info btn-sm text-white';
        var btl='Sent';
      }else{  
        var shbtn='mr-10 mb-10 btn btn-secondary btn-sm text-white';
        var btl='Send Email';
      }
      const mailbtn=(
        <MatButton className={shbtn} onClick={() => this.onSendEmail(assmntval.ctsaID)}>
          {btl}
        </MatButton>
     );
      return {
        sno: idx + 1,
        student: assmntval.studentname,
        agreementtype: assmntval.agreementtype,
        executiondate: assmntval.exdate,
        startdate: assmntval.stdate,
        enddate: assmntval.eddate,
        action:mailbtn,
      };
    });


    return (
      <div className="saas-dashboard">
        {this.state.viewdiv && (
          <>
          <div className="col-sm-12 col-lg-12">
            <MUIDataTable data={tableData} columns={columns} options={options} />
          </div>
          <div className="col-sm-12 col-lg-12" style={{marginTop:"50px"}}>
            <h1 className='text-center'>Month-wise List</h1>
            
                <div className="form-group col-sm-12 col-xl-4" style={{marginBottom:"30px"}}>
                <label className="form-control-label" htmlFor="input-username">Select Month </label>
                <FormGroup>
                  <Label for="Select" style={{ fontWeight: "bold" }}>Select Month</Label>
                  <Selectsearch
                    id="month"
                    name="month"
                    options={months}
                    value={months.find(obj => obj.value === this.state.selectedMonth)}
                    onChange={this.handleChange}
                    required
                  />
                </FormGroup>
              
            </div>
          
          </div>
          {viewmonth && (
              <div className="col-sm-12 col-lg-12">
                <MUIDataTable data={tableData2} columns={columns} options={options} />
              </div>
            )}
          </>
        )}
        {/* ... other JSX components */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { contractDashboard } = state;
  return {
    contractendinglist: contractDashboard.contractendinglist,
    loading: contractDashboard.loading,
    monthcontract : contractDashboard.monthcontractlist,
  };
};

export default connect(mapStateToProps, {
  getEndingContract,
  getMonthEndContract,
  emailContractEnding,
})(ContractsEndings);
